export var LocalStorage;
(function (LocalStorage) {
    LocalStorage["DASHBOARD_SORT_FILTER"] = "__dp_dashboard_sort_filter";
})(LocalStorage || (LocalStorage = {}));
